import React from 'react';
import { useTranslation } from 'react-i18next';
import { getBEMClasses } from '../helpers/cssClassesHelper';

import withAuthentication from '@alphapoint/apex-web/lib/hocs/withAuthentication';
import {
  BuySellContainer,
  BuySellMakeTransactionContainer,
  BuySellBalancesContainer,
  BuySellOrderOverviewContainer
} from '@alphapoint/apex-web/lib/components/Retail/RetailBuySell';
import '@alphapoint/apex-web/lib/layouts/Responsive/EotcBuySellLayout/EotcBuySellDesktopLayout.css';

import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';

import './BuySellPage.css';

const classes = getBEMClasses('eotc-buy-sell-layout');

const BuySellPage = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className={classes('accent-bar')} />
      <div className={classes('container')}>
        <div className={classes('col', ['lg'])}>
          <div className={classes('make-transaction-container container-with-shadow')}>
            <div className={classes('make-transaction-col-1 ')}>
              <BuySellMakeTransactionContainer>
                <BuySellContainer />
              </BuySellMakeTransactionContainer>
            </div>

            <div className={classes('make-transaction-col-2')}>
              <div className={classes('order-overview-container')}>
                <BuySellOrderOverviewContainer displayPricePerUnit />
              </div>

              <hr className={classes('right-panel-divider')} />

              <div className={classes('balances-container ')}>
                <div className={classes('balances-title')}>{t('Balances')}</div>
                <BuySellBalancesContainer />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes('footer')}>
        <PageFooterLayout />
      </div>
    </React.Fragment>
  );
};

export default withAuthentication(BuySellPage);
